export default {
  environment: process.env.REACT_APP_ENVIRONMENT || "development",
  apiHost: process.env.REACT_APP_API_HOST || "http://localhost:5000",
  debug: JSON.parse(process.env.REACT_APP_DEBUG || "true"),
  chaos: JSON.parse(process.env.REACT_APP_CHAOS || "false"),
  videoDebug: JSON.parse(process.env.REACT_APP_VIDEO_DEBUG || "false"),
};
